import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';

/**
 * TotalTerritoire
 *
 * Fil de fer (Phase 1) : la navigation est câblée, le contenu arrive en
 * Phase 6.
 * Contenu prévu : port Shiny onglet 'Total territoire', mock
 */
export default function TotalTerritoire() {
  const { idExploit } = useOAD();

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="2026-2027"
        niveau2="eau-3-mois"
        niveau3="territoire"
        idExploit={idExploit}
      />
      <main className="oad-cards">
        <div className="oad-card oad-card-placeholder">
          <h2>TotalTerritoire</h2>
          <p>port Shiny onglet 'Total territoire', mock</p>
        </div>
      </main>
    </div>
  );
}
